import { createFileRoute, redirect } from '@tanstack/react-router'
import { productOfferingsQuery } from '../../../../data/service.ts'
import { SubscriptionForm } from '../../../../features/serviceManagement/accounts/SubscriptionForm.tsx'

export const Route = createFileRoute('/_app/smp/accounts/$customerId/add')({
	component: RouteComponent,
	loader: async ({ context: { customers, queryClient }, params }) => {
		await queryClient.ensureQueryData(productOfferingsQuery)
		const customer = customers.find((customer) => customer.id === params.customerId)
		if (!customer) {
			throw redirect({ to: '/smp/accounts' })
		}
		return { customer }
	},
})

function RouteComponent() {
	const { customer } = Route.useLoaderData()
	return <SubscriptionForm customer={customer} />
}
